import ApiService from '../../../services/apiService';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import { mapMutations, mapState, mapGetters } from 'vuex';
import { userItemsPerListMixin } from '@/utils/vuex';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewISFMTicketingMgmt',
  mixins: [userItemsPerListMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      canReadUsers: false,
      authorNames: {},
      fab: false,
      search: null,
      dialog: false,
      tableLoading: false,
      editedIndex: -1,
      editedItem: {},
      editedItemHasCloseDate: false,
      expanded: [],
      selected: [],
      tableOptions: {
        ...defaultTableOptions
      },
      items: [],
      state: [{
        text: this.$i18n_t('Common.toDo'),
        value: 0
      }, {
        text: this.$i18n_t('Common.inProgress'),
        value: 1
      }, {
        text: this.$i18n_t('Common.done'),
        value: 2
      }],
      newComment: {
        date: new Date(),
        type: null,
        comment: null
      },
      fileURL: null,
      dateFromMenu: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    ...mapGetters({
      sessionPrimaryTenantIds: 'authentication/primaryTenantIds',
      userObject: 'authentication/user'
    }),
    formTitle() {
      return this.editedIndex === -1 ? this.$i18n_t('Common.newRecord') : this.$i18n_t('Common.editRecord');
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    tableLocalizations() {
      return {
        headers: [{
          sortable: false,
          text: '',
          value: '',
          width: 30
        }, {
          sortable: true,
          text: this.$i18n_t('Common.tbl_subject'),
          class: 'tableHeader',
          value: 'subject',
          width: 150
        }, {
          sortable: true,
          text: this.$i18n_t('Common.state'),
          value: 'statusUi.text',
          width: 100
        }, {
          sortable: true,
          text: this.$i18n_t('Common.type'),
          value: 'type.name',
          width: 100
        }, {
          sortable: true,
          text: this.$i18n_t('Common.dTwin'),
          value: 'properties.dTwin.title',
          width: 160
        }, {
          sortable: true,
          text: this.$i18n_t('Common.comment'),
          value: 'lastComment'
        }, {
          sortable: true,
          text: this.$i18n_t('Common.createdDate'),
          value: 'createdAt',
          width: 100
        }, {
          sortable: false,
          text: '',
          value: '',
          width: 50
        }, {
          sortable: false,
          text: '',
          width: 50
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50]
        }
      };
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  mounted() {
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
    this.$store.state.app.loading = false;
    this.fetchTickets();
    this.canReadUsers = this.permissions['UserManagement.read'];
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    shouldExpand(item) {
      if (this.expanded.length === 0 || this.expanded[0].id !== item.id) {
        const expand = item.properties && item.properties.fileId || this.canReadUsers || item.comments.length > 0;
        if (expand) {
          // details for this ticket will be expanded, so fetch the author-name
          this.fetchAuthorName(item);
        }
        return expand;
      }
      return false;
    },
    editTicket(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItemHasCloseDate = item.closedDate;
      if (this.editedItemHasCloseDate) {
        this.editedItem.closedDate = new Date(this.editedItem.closedDate);
      }
      this.editedItem.fileURL = item.properties && item.properties.fileId ? this.getImageURL(item.properties.fileId) : null;
      this.editedItem.imageRotate = item.properties && item.properties.imageRotate ? item.properties.imageRotate : 0;
      this.dialog = true;
    },
    fetchTickets() {
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.tableLoading = true;
      ApiService.isFmTicketsFetch(this).then(data => {
        this.items = data.map(row => {
          row.statusUi = this.state.find(ele => ele.value === row.status);
          row.lastComment = row.comments && row.comments.length ? row.comments[row.comments.length - 1].comment : null;
          return row;
        });
        if (!data.length) {
          this.$snack(this.$i18n_t('IS.FM.Ticket.noTickets'), 'success');
        }
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('IS.FM.Ticket.errorFindingTicket'), 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
        this.tableLoading = false;
      });
    },
    fetchAuthorName(ticket) {
      if (this.canReadUsers) {
        if (this.authorNames[ticket.authorId]) {
          return;
        }
        ApiService.getUser(this, ticket.authorId).then(data => {
          this.authorNames[ticket.authorId] = `${data.firstName} ${data.lastName}`;
          this.authorNames = cloneDeep(this.authorNames);
        }).catch(() => {
          this.authorNames[ticket.authorId] = this.$i18n_t('IS.FM.Ticket.noUserReadPermission');
          this.authorNames = cloneDeep(this.authorNames);
        });
      }
    },
    editAuthor(authorId) {
      this.$router.push(`/account-mgmt/user/${this.sessionPrimaryTenantIds[0]}/${authorId}`);
    },
    confirmDeleteTicket(item) {
      confirm(this.$i18n_t('Common.areYouSure')) && this.deleteTicket(item);
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.clearFields();
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      if (this.editedIndex > -1) {
        this.updateTicket();
      }
    },
    updateTicket() {
      this.tableLoading = true;
      if (this.editedItem.type && this.editedItem.type.name) {
        this.newComment.type = this.editedItem.type.name;
      }
      this.newComment.date = new Date();
      this.editedItem.comments.push(this.newComment);
      ApiService.isFmTicketUpdate(this.editedItem).then(() => {
        this.clearFields();
        this.close();
        this.fetchTickets();
        this.$snack(this.$i18n_t('IS.FM.Ticket.updateTicketObj'), 'success');
        this.$store.state.app.refreshToolbar += 1;
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('IS.FM.Ticket.updateTicketObjFaild'), 'error');
        }
      });
    },
    deleteTicket(item) {
      this.tableLoading = true;
      ApiService.isFmTicketDelete(item.id).then(() => {
        this.$snack(this.$i18n_t('IS.FM.Ticket.deleteTicketObj'), 'success');
        this.$store.state.app.refreshToolbar += 1;
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('IS.FM.Ticket.deleteTicketObjFaild'), 'error');
        }
      }).finally(() => {
        this.fetchTickets();
      });
    },
    getStatusText(id) {
      let state = this.state.find(ele => ele.value === id);
      return state.text;
    },
    date(date, time = false) {
      if (date) {
        var locale = window.navigator.userLanguage || window.navigator.language;
        moment.locale(locale);
        return time ? moment(date).format('L LT') // produces a localised version of 'DD/MM/YYYY hh:ss:ii A'
        : moment(date).format('L'); // produces a localised version of 'DD/MM/YYYY'
      }
    },
    closedDatePicked(dateObject) {
      this.editedItem.closedDate = new Date(dateObject.from * 1000);
    },
    getImageURL(fileId) {
      if (fileId) {
        return `${this.$store.state.app.baseURL}/upload/${fileId}`;
      }
    },
    clearFields() {
      this.editedItem = {};
      this.newComment.comment = null;
    },
    imageRotate(turn) {
      if (turn) {
        return {
          transform: `rotate(${turn}turn)`
        };
      }
    }
  }
};